import NotificationProvider from "../NotificationProvider";
import * as DomBuilder from "./dom-builder.js";
import * as FormatError from "../format-error.js";

/**
 *
 * @version 2026-09-03
 * @author Patrik Harag
 */
export default class DialogNotificationProvider extends NotificationProvider {
    /** @type {HTMLElement} */
    #dialogAnchorNode;
    /** @type {Logger} */
    #logger;

    /**
     *
     * @param dialogAnchorNode {HTMLElement}
     * @param logger {Logger}
     */
    constructor(dialogAnchorNode, logger) {
        super();
        this.#dialogAnchorNode = dialogAnchorNode;
        this.#logger = logger;
    }

    handleError(title, e) {
        console.error(title, e);

        this.#logger.addError(title, e);

        let dialog = DomBuilder.bootstrapDialogBuilder();
        dialog.setHeaderContent("Error");
        dialog.setBodyContent([
            DomBuilder.par(null, title + ': '),
            DomBuilder.element('code', null, FormatError.format(e))
        ]);
        dialog.addCloseButton('Close');
        dialog.show(this.#dialogAnchorNode);
    }

    handleInfo(title, description) {
        console.log(title + ': ' + description);

        this.#logger.addInfo(title, description);

        let dialog = DomBuilder.bootstrapDialogBuilder();
        dialog.setHeaderContent(title);
        dialog.setBodyContent(DomBuilder.par(null, description));
        dialog.addCloseButton('Close');
        dialog.show(this.#dialogAnchorNode);
    }
}